import React from "react";
import { FaRegEdit } from "react-icons/fa";

const EditButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-6 h-6 flex justify-center items-center bg-blue-100 text-blue-500 rounded-full scale-100 hover:scale-110 duration-300"
    >
      <FaRegEdit />
    </button>
  );
};

export default EditButton;
